import { z } from "zod";



export const CompanyFormSchema = z.object({
    name: z.string().min(1, { message: 'This field is required' }),
    number: z.string().transform(value => value.replace(/\s+/g, ''))
        .pipe(z.string().min(1, { message: 'This field is required' })),
    website: z.string().min(1, { message: 'This field is required' }),
})